import { lazy } from 'react';

// const BalanceSheet = lazy(() =>
//   import('../pages/BalanceSheetNewFormat/BalanceSheet'),
// );

const BalanceSheetNew = lazy(() =>
  import('../pages/BalanceSheetNewFormat/BalanceSheet/new'),
);

const balanceSheetNewFormatRoute = {
  public: [],
  auth: [
    // {
    //   name: 'balance_sheet_v2',
    //   path: '/finance-and-accounting/balance-sheet-old-v2',
    //   component: BalanceSheet,
    // },
    {
      name: 'balance_sheet_new_v2',
      path: '/finance-and-accounting/balance-sheet-v2',
      component: BalanceSheetNew,
    },
  ],
};

export default balanceSheetNewFormatRoute;
